import React, {  useState } from "react";
import { Modal, Button ,Menu } from 'antd';

import FormInput from "../../form-input/form-input.component";
import { connect } from "react-redux";
import { updateExercise } from "../../../actions/Exercise.actions";
import { setAlert } from "../../../actions/alert";
import {EditOutlined} from "@ant-design/icons"
  const UpdateLesson = ({ updateExercise, correntExercise, setAlert,courseId }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const [Lesson, setLesson] = useState({
    id: correntExercise._id,
    title: correntExercise.title,
  });

  const { title } = Lesson;
  const onChange = (e) => {
    setLesson({ ...Lesson, [e.target.name]: e.target.value });
  };
  const onSubmit = async (e) => {
    e.preventDefault();
    updateExercise(Lesson ,courseId);
    setAlert("تم التعديل علي بيانات التمرين", "success");
    setIsModalVisible(false);
  };

  return (
    <>
    {/* eslint-disable-next-line */}
    <a  className="lesson-config" onClick={showModal}>
      <EditOutlined />
    </a>
    <Modal title="التعديل على التمرين" visible={isModalVisible} onOk={handleOk} onCancel={handleCancel}
    footer={[
    <Button key="back" onClick={handleCancel}>
      إلغاء الامر
    </Button>,
    <Button key="submit" type="primary"  onClick={onSubmit}>
      تعديل
    </Button>,
    ]}
    >
    <form onSubmit={onSubmit}>
    <FormInput
      name="title"
      type="text"
      handleChange={onChange}
      value={title}
      label="عنوان التمرين"
      required
    />
    </form>
    </Modal>
  </>

     
  );
};

export default connect(null, {
  updateExercise,
  setAlert,
})(UpdateLesson);
